import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { ServiceProvider } from "./contexts/ServiceContext";
import AppRouter from "./components/Router";

// 主应用组件
const App: React.FC = () => {
  return (
    <AuthProvider>
      <ServiceProvider>
        <div className="app">
          <AppRouter />
        </div>
      </ServiceProvider>
    </AuthProvider>
  );
};

export default App;
